import { useMediaQuery, useTheme } from "@mui/material";

export interface UseScreenSizeResult {
    isMobile: boolean;
    isTablet: boolean;
    isSmallDesktop: boolean;
    isDesktop: boolean;
}

/**
 *
 * @returns booleans for device size and breakpoint media queries
 */
export const useScreenSize = (): UseScreenSizeResult => {
    const theme = useTheme();

    /**
     * non overlapping device size media queries
     */
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const isSmallDesktop = useMediaQuery(theme.breakpoints.between("md", "lg"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

    return { isMobile, isTablet, isSmallDesktop, isDesktop };
};
